module.exports = __webpack_public_path__ + "img/launch.0.1.c64438ad.png";